import React, { Component } from "react";
import { Link } from "react-router-dom";
import store from "../../../store";
import { RecoverPasswordAction } from "../../../actions/user/login";
import { TO_EXTERNAL_LOGIN } from "../../../helpers/constants";
import { AuthField, AuthShell, AuthStatus } from "../auth-shell";

class PasswordRecoverForm extends Component {
  state = { email: "", error: "", submitted: false, complete: false, requestError: "" };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)) {
      this.setState({ error: "Enter the email address associated with your account." });
      return;
    }
    this.setState({ submitted: true, error: "", requestError: "" });
    const result = await store.dispatch(RecoverPasswordAction({ email: this.state.email, data: this.state.email }));
    if (result && result.status) {
      this.setState({ submitted: false, complete: true });
    } else {
      this.setState({ submitted: false, requestError: result && result.msg ? result.msg : "We couldn't send reset instructions. Try again." });
    }
  };

  render() {
    if (this.state.complete) {
      return <AuthShell eyebrow="Account recovery" title="Check your email" compact footer={<Link to={TO_EXTERNAL_LOGIN}>Back to external user sign in</Link>}><AuthStatus icon="fa-envelope" title="Reset instructions requested"><p>If an account matches <strong>{this.state.email}</strong>, reset instructions will arrive shortly. Check your spam folder if needed.</p><Link className="auth-primary" to={TO_EXTERNAL_LOGIN}>Return to sign in</Link></AuthStatus></AuthShell>;
    }

    return (
      <AuthShell eyebrow="Account recovery" title="Reset your password" description="Enter your account email and we'll send you a secure reset link." compact footer={<Link to={TO_EXTERNAL_LOGIN}>Back to external user sign in</Link>}>
        <form className="auth-form" onSubmit={this.handleSubmit} noValidate>
          <AuthField label="Email address" id="recover-email" name="email" type="email" autoComplete="email" value={this.state.email} onChange={(event) => this.setState({ email: event.target.value, error: "" })} error={this.state.error} />
          {this.state.requestError && <div className="auth-inline-error" role="alert">{this.state.requestError}</div>}
          <button className="auth-primary" type="submit" disabled={this.state.submitted}>{this.state.submitted ? "Sending reset link..." : "Send reset link"}</button>
          <p className="auth-help">For security, use the email address registered with your BlueSky account.</p>
        </form>
      </AuthShell>
    );
  }
}

export default PasswordRecoverForm;
